<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.create_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Registrar institución</v-toolbar-title>
            </v-toolbar>
            <v-container>
                <v-form v-model="form" ref="store" v-on:submit.prevent="submit($event)">
                    <v-row align="center" justify="center">
                        <v-col lg="6" md="8" sm="12" xs="12">
                            <v-text-field v-model="code" filled :color="color" label="Código de la institución" :rules="[rules.required]"></v-text-field>
                            <v-text-field v-model="name" filled :color="color" label="Nombre de la institución" :rules="[rules.required]"></v-text-field>
                            <v-text-field v-model="proof_type" filled :color="color" label="Tipo de comprobante" :rules="[rules.required]"></v-text-field>
                            <v-text-field v-model="per_person" type="number" filled :color="color" label="Acuerdo por persona (Institución)" :rules="[rules.required]"></v-text-field>
                            <v-text-field v-model="total_allowed" type="number" filled :color="color" label="Personas permitidas por referencia" :rules="[rules.required]"></v-text-field>
                            <v-text-field v-model="discount" type="number" filled :color="color" label="Cantidad de descuento" :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" lg="6" md="10" class="text-right mx-auto">
                            <v-btn type="submit" :loading="loading" color="#008dd4" dark>Registrar</v-btn>
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props: ['dialog', 'post_url'],
    data: () => ({
        color:"#000",
        loading:false,
        form:false,

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        //models
        code:"",
        name:"",
        per_person:"",
        proof_type:"",
        total_allowed:"",
        discount:"",
    }),

    methods:{
        submit:function(){
            if(this.$refs.store.validate()){
                this.loading = true
                let data = {}
                data.code = this.code
                data.name = this.name
                data.per_person = this.per_person
                data.proof_type = this.proof_type
                data.total_allowed = this.total_allowed
                data.discount = this.discount
                axios.post(this.post_url, data).then(response => {

                    this.cancel()
                    iziToast.success({
                        title:"Correcto",
                        position:"topRight",
                        message:"Intituto registrado correctamente"
                    })

                    this.$parent.getItems()

                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })
            }
        },

        cancel:function(){
            this.loading = false
            this.$refs.store.reset()
            this.$parent.create_dialog = false
        }
    }
}
</script>
